module.exports = __webpack_public_path__ + "7b2d3410782e869e40f84022b5b711a2.svg";